import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=4ff27920&scoped=true&"
import script from "./Body.vue?vue&type=script&lang=js&"
export * from "./Body.vue?vue&type=script&lang=js&"
import style0 from "./Body.vue?vue&type=style&index=0&id=4ff27920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff27920",
  null
  
)

export default component.exports